module.exports = __webpack_public_path__ + "static/media/idcard.b569a74f.png";